
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/the-other-climate-crisis",
      function () {
        return require("private-next-pages/stories/the-other-climate-crisis.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/the-other-climate-crisis"])
      });
    }
  